import * as React from "react";

interface IProps {
    children: any;
    className?: string;
    title?: string;
    ariaLabel?: string;
    type?: "a" | "button";
    href?: string;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent) => void;
}

const SimpleButton = ({ children, className, title, ariaLabel, type, href, disabled, onClick }: IProps) => {
    return type === "a" ? (
        <a
            className={className}
            href={href}
            onClick={onClick}
            title={title}
            aria-label={ariaLabel}
        >
            {children}
        </a>
    ) : (
        <button
            className={className}
            onClick={onClick}
            title={title}
            aria-label={ariaLabel}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default SimpleButton;
